(function () {
  'use strict';

  // Every product card renders its own one-click "הוסף לעגלה". For a colour-choice
  // set that button is a trap: on a collection page the picker isn't loaded at all,
  // so the set lands in the cart with no colours, deducts nothing, and nobody knows
  // what to pack (orders #8728 and #9202). This turns that one button, on those
  // products only, into a link to the product page where the colours get chosen.
  //
  // Everything else on the page is left alone: wrong products, the main product
  // form (saturn-set-builder owns that one), and any card already carrying the
  // builder's own buttons.

  var API_BASE = String(
    (window.SaturnBuilderConfig && window.SaturnBuilderConfig.apiBase) ||
    'https://ceramora-cashier-production.up.railway.app'
  ).replace(/\/$/, '');

  var LABEL = 'בחירת גוונים';
  var variantIds = null;

  function builderProductId() {
    return window.SaturnBuilderConfig ? String(window.SaturnBuilderConfig.productId || '') : '';
  }

  function productLinkFor(form) {
    var card = form.closest('product-card, .product-card, .card, li, article');
    for (var hops = 0; card && hops < 4; hops++) {
      var link = card.querySelector('a[href*="/products/"]');
      if (link) return link.getAttribute('href');
      card = card.parentElement ? card.parentElement.closest('product-card, .product-card, .card, li, article') : null;
    }
    return '';
  }

  function guardForm(form) {
    if (form.querySelector('.saturn-card-choose, .saturn-cta-group')) return;

    var variantInput = form.querySelector('input[name="id"]');
    if (!variantInput || variantIds.indexOf(String(variantInput.value)) === -1) return;

    // The product's own page: saturn-set-builder puts the real picker on every form
    // there, including the cards. Sending someone from that page to that page helps
    // nobody.
    var formId = form.getAttribute('id') || '';
    if (builderProductId() && formId.indexOf(builderProductId()) !== -1) return;

    var href = productLinkFor(form);
    if (!href) return; // no way to send them anywhere — leave the card exactly as it was

    // One link per button, wearing that button's own classes. A card renders two
    // add-to-cart buttons - a full-width one for mouse (touch:hidden) and an icon
    // one for touch (no-touch:hidden) - so a single replacement styled after the
    // first would leave phones with no button at all.
    var buttons = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"]'));
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      var link = document.createElement('a');
      link.className = button.className + ' saturn-card-choose';
      link.setAttribute('href', href);
      var wording = button.textContent.trim();
      // Keeps the cart icon and the screen-reader text in place, only swapping what
      // the button says it does.
      link.innerHTML = wording ? button.innerHTML.split(wording).join(LABEL) : LABEL;
      button.insertAdjacentElement('beforebegin', link);
    });

    Array.prototype.forEach.call(
      form.querySelectorAll('button[type="submit"], [data-shopify="payment-button"]'),
      function (control) { control.style.display = 'none'; }
    );
  }

  function guardAll() {
    if (!variantIds || !variantIds.length) return;
    Array.prototype.forEach.call(document.querySelectorAll('form[action*="/cart/add"]'), guardForm);
  }

  var pending = null;
  function scheduleGuard() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      try { guardAll(); } catch (error) {}
    }, 80);
  }

  function start() {
    fetch(API_BASE + '/api/public/customer-choice-variants')
      .then(function (response) {
        if (!response.ok) throw new Error('variant list request failed');
        return response.json();
      })
      .then(function (list) {
        variantIds = (list || []).map(function (b) { return String(b.variantId); });
        guardAll();
        // Cards arrive late: carousels, infinite scroll, quick-buy modals, and the
        // theme re-rendering a card after a stock refetch.
        if (window.MutationObserver) {
          new MutationObserver(scheduleGuard).observe(document.body, { childList: true, subtree: true });
        }
      })
      .catch(function () {
        // Leave the page untouched. The server still picks colours for any set that
        // arrives without them, so this is a worse experience, never a wrong order.
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
